import './index.css'
import {useNavigate} from "react-router-dom";
import {ReactComponent as RiCloseLine} from '@/assets/icons/ri-close-line.svg'


const Header: React.FC<HeaderProps> =
	({
		 children = null,
		 title = null
	 }: HeaderProps) => {
		const navigate = useNavigate()
		const goBack = () => navigate(-1)

		return (
			<div className="base-header print-none">
				<div className="flex gap-4">
					<button onClick={goBack}>
						<RiCloseLine/>
					</button>
					<div className="base-header-separator"/>
					<span>
          {title}
        </span>
				</div>
				<div>
					{children}
				</div>
			</div>
		)


	}
export default Header;
